import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import './assets/styles/theme.scss';
import 'normalize.css/normalize.css';

import Header from './components/layout/header.vue';
import Landing from './components/landing/landing.vue';
import SideNavigation from './components/layout/side-navigation.vue';
import BackgroundParticles from '@/components/layout/background-particles/background-particles.vue';
import Services from '@/components/landing/services.vue';
import About from '@/components/landing/about.vue';
import ContactUs from '@/components/modal/contact-us.vue';
import ErrorMessage from './components/forms/error-message.vue';
import ButtonCompact from './components/layout/contact-us-button-compact.vue';
import Notification from './components/notification.vue';

// Layout
Vue.component('es-header', Header);
Vue.component('es-side-navigation', SideNavigation);
Vue.component('es-background-particles', BackgroundParticles);
Vue.component('es-contact-us-button-compact', ButtonCompact);

// Pages
Vue.component('es-landing', Landing);
Vue.component('es-services', Services);
Vue.component('es-about', About);

// Modal
Vue.component('es-contact-form-modal', ContactUs);

// Forms
Vue.component('es-error-message', ErrorMessage);

Vue.component('es-notification', Notification);

Vue.config.productionTip = false;

new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
